export const getImageForFormat = (media, format) => {
  const foundFormat = media.formats[format];
  if (foundFormat) return foundFormat.url;
  else return media.url;
};
